import React, {useState, useEffect, useMemo} from 'react'
import { usePaletteTheme } from '../../../context/paletteTheme'
import DropdownFinancial from '../../visualization-dropdown/DropdownFinancial'
import { Grid, SvgIcon } from '@mui/material'
import DatasetButton from '../../visualization-dropdown/DatasetButton'
import { useSection } from '../../../context/section'
import useDatasets from '../../../pages/visualization/hooks/useDatasets'
import { DatasetProvider, useDataset } from '../../../context/dataset'
import ButtonActive from '../../ui/ButtonActive'
import { PlayArrowOutlined } from '@mui/icons-material'
import KpiEditor from '../../visualization-dropdown/KpiEditor'
import styles from './ResearchSection.module.scss'
import {_} from 'lodash'

function GridItem(props) {
    return (
        <Grid item xs={6} md={3} {...props}>
            {props.children}
        </Grid>
    )
}

const Default_KPIs = ["revenue","earningsPerShare","analyst_estimated_net_income","analyst_estimated_eps","analyst_estimated_revenue","netIncome","stockPrice","volume","EBITDA","analyst_estimated_net_income_final","analyst_estimated_revenue_final","analyst_estimated_eps_final"]
export default function VisualizationSelector({ticker}) {
    const { updateAnalyze, selectedData, handleUpdateDataset,ColumnGranularityOptions,setSelectedDataset,updateDatasets,setSelectedAggregationBy } = useSection()
    const { getColumns, datasets } = useDatasets(ticker)
    const { financialInfo, dataset, NowcastingfinancialInfo } = selectedData
    const [ updatedDataset, setupdatedDataset] = useState(dataset)
    const [kpiEditorIndex, setKpiEditorIndex] = useState('')
    
    const datasetProviderProps = {ticker, dataset, handleUpdateDataset, getColumns, datasets}

    const openKpiEditor = (index) => setKpiEditorIndex(index)
    const openKpiEditorGeneral = () => setKpiEditorIndex(0)
    const exitKpiEditor = () => setKpiEditorIndex('')
    const updateKpiAndRun = () => {
        exitKpiEditor()
        updateAnalyze()
    }

    const datasetConainer = ()=>{
        let datasetArray = []
        const kpiProps = {openKpiEditor, kpiEditorIndex, isKpiOpen}
        for(let index = 0 ; index < 4 ; index++){
            const DatasetButtonProps = {index, ...datasetProviderProps}
            datasetArray.push(
                <GridItem key={index}>
                    <DatasetProvider {...DatasetButtonProps}>
                        <DatasetButton kpi_unselected={index !== kpiEditorIndex && kpiEditorIndex !== '' } {...DatasetButtonProps} {...kpiProps}/>
                    </DatasetProvider>
                </GridItem>)}
        return datasetArray
    }

    const isKpiOpen = kpiEditorIndex !== '' 


    // const temp = useMemo(()=>{
    //     if (financialInfo && dataset){            
    //         let Datatemp = []
    //         dataset?.map((x,i)=>{
    //             let curretDataset = x
    //             if (Default_KPIs.includes(financialInfo)){
    //                 const temp = ColumnGranularityOptions.filter(item=>item.dataset_name==dataset[i].datasetValue).filter(item=>item.column==dataset[i].columnValue).filter(item => item.kpi_name==financialInfo)
    //                 curretDataset = {
    //                     ...curretDataset,
    //                     agg:temp[0]?.agg_method,
    //                     group:temp[0]?.group_by
    //                 }

    //                 // setSelectedGroupBy(temp[0]?.group_by, i, 'daily')    
    //                 // setSelectedAggregationBy(temp[0]?.agg_method,i,temp[0]?.group_by)
    //             }
    //             else{
    //                 curretDataset = {
    //                     ...curretDataset,
    //                     agg:"sum",
    //                     group:"quarterly"
    //                 }
    //             // setSelectedGroupBy('quarterly', i, 'daily')    
    //             // setSelectedAggregationBy('sum',i,'quarterly')
    //             }
    //             Datatemp.push(curretDataset)
    //         })
    //         // setSelectedDataset(Datatemp)  
    //         setupdatedDataset(Datatemp)
    //         return Datatemp 

    //         }

    // },[financialInfo,dataset])


    // useMemo(()=>{
    //     if (updatedDataset?.length && JSON.stringify(updatedDataset) != JSON.stringify(dataset)){
    //         updateDatasets(updatedDataset)
    //     }
    // },[updatedDataset])

    return (
        <div className={styles["choose-data-header"]}>
            <Grid container spacing={3}>
                <Grid item xs={6} md={6}>
                    <DropdownFinancial financialInfo={financialInfo} ticker={ticker} type={"main"}/> 
                </Grid>
                <Grid item xs={6} md={6} className={styles["analyze-button"]}>
                    <button className={styles['kpi-button']} onClick={isKpiOpen ? exitKpiEditor : openKpiEditorGeneral}><KpiEditorIcon/><div>{isKpiOpen && 'Exit '}KPI Editor</div></button>
                    {isKpiOpen 
                    ? <button className={styles['update-button']} onClick={updateKpiAndRun}>Update</button>
                    : <ButtonActive style={{height: '48px',backgroundColor:'#dccb03', color:'black'}} variant="contained" size="large" startIcon={<PlayArrowOutlined style={{ fontSize: 30 }}/>} onClick={updateAnalyze}>Run</ButtonActive>}
                </Grid>
                {datasetConainer()}
                {isKpiOpen && <DatasetProvider index={kpiEditorIndex} {...datasetProviderProps}>
                    <KpiEditor dataset={dataset} index={kpiEditorIndex} openKpiEditor={openKpiEditor} ticker={ticker} financialInfo={financialInfo} key={`${ticker}_${kpiEditorIndex}`}/>
                </DatasetProvider>}
            </Grid>
        </div>
    )
}

const KpiEditorIcon = () => {
    const { colors } = usePaletteTheme()
    return (
        <SvgIcon>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 21V14M4 10V3M12 21V12M12 8V3M20 21V16M20 12V3M1 14H7M9 8H15M17 16H23" stroke={colors.textPrimary} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
        </SvgIcon>
    )
}